import { UntypedFormGroup } from '@angular/forms';

export abstract class MeasurementsAbstractComponent {
  abstract form: UntypedFormGroup;

  formDecimalInputChange(event: Event, formControlName: string, minValue = 1) {
    let value = (event.target as HTMLInputElement).value.replace(',', '.').replace(/\s/g, '');
    if (value !== '' && Number(value) <= 0) {
      value = `${minValue}`;
    }
    this.form.controls[formControlName].patchValue(value);
  }

  getNotInMetersWarningText(formControlName: string): string {
    return `Ai vrut să scrii ${(this.form?.controls?.[formControlName]?.value / 100).toFixed(2)} metri ?`;
  }

  updateToMeters(formControlName: string): void {
    this.form.controls[formControlName].patchValue((this.form.controls[formControlName].value / 100).toFixed(2));
  }
}
